import { type OnDemandActivationModalState, type OnDemandActivationUIState } from './types';

export const SET = 'ui.onDemandActivation.SET';
export type SetPayload = OnDemandActivationUIState;
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});

export const UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE = 'UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE';

export const updateOnDemandActivationModalState = ({
	modalState,
}: {
	modalState: OnDemandActivationModalState;
}) => ({
	type: UPDATE_ONDEMAND_ACTIVATION_MODAL_STATE,
	payload: {
		modalState,
	},
});
